import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef, useImperativeHandle, useRef, useState } from 'react';
import { BottomSheet } from '../BottomSheet/BottomSheet.js';
import { TokenDetailsSheetContent } from './TokenDetailsSheetContent.js';
export const TokenDetailsSheet = forwardRef((_, ref) => {
    const bottomSheetRef = useRef(null);
    const [tokenAddress, setTokenAddress] = useState(undefined);
    const [chainId, setChainId] = useState(undefined);
    const [withoutContractAddress, setWithoutContractAddress] = useState(false);
    useImperativeHandle(ref, () => ({
        isOpen: () => bottomSheetRef.current?.isOpen(),
        open: (address, noContractAddress, chainId) => {
            setTokenAddress(address);
            setWithoutContractAddress(noContractAddress);
            setChainId(chainId);
            bottomSheetRef.current?.open();
        },
        close: () => {
            bottomSheetRef.current?.close();
        },
    }), []);
    return (_jsx(BottomSheet, { ref: bottomSheetRef, keepMounted: true, children: _jsx(TokenDetailsSheetContent, { ref: ref, tokenAddress: tokenAddress, withoutContractAddress: withoutContractAddress, chainId: chainId }) }));
});
//# sourceMappingURL=TokenDetailsSheet.js.map